import { initAccordion } from "../../general.end";
import { initNativeSelect, processMarkedForRemove, replaceContentSmooth, getParameterByName } from "../../helpers";
import { getTranslations } from "../../translations";
import { sendApiCall } from "../../utilities/api";
import { Popup, PopupContent, PopupContentOptions, PopupPosition, PopupButton } from "../../utilities/popup";
import { progressSpinner, spinnerType } from "../../utilities/progressSpinner";
import { reInitSlider } from "../../utilities/slider";
import { FavoritePopup } from "../../widget/favorites/favorites.popup";
import { stickybar } from "../../widget/stickybar";
import { sendBreadCrumbImpression } from "../ecommerce/breadcrumb";
import { getProductDetailImpression, sendDataLayer } from "../ecommerce/ecommerce";
import { updateSideImage } from "../instagram/instagram";
import { sendLastViewedProduct } from "../lastViewed/lastViewed";
import { metaManager, PageMeta } from "../metaManager";
import { reInitProductComparer } from "../productcomparer/productcomparer.popup";
import { loadCart } from "../shoppingcart/cartpopup";
import { addArticleToCart, deleteOrderLine, updateCartQuantity } from "../shoppingcart/shoppingcart";
import { reInitTooltips, Tooltip } from "../tooltip/tooltip";
import { reInitYoutubePlayer } from "../video/video";
import { reInitAr } from "./ar.popup";

type SelectionSource = HTMLSelectElement | HTMLElement;

declare global
{
    interface Window
    {
        _sqzl: any;
    }
};

const isProductfeed = getParameterByName("productfeed") === "1";

declare function initLazyLoad(): void;
const useColorPopup = false;
declare let buttonInfoList: any;
declare let buttonImpressionList: any;
let stickybarInstance: stickybar;

const GRID_PROPERTIES = [
    "property3_mobile",
    "property3"
];

const STICKY_PROPERTIES = [
    "property5"
];

const OPTIONS = [
    "sheet",
    "molton",
    "pillowprotector",
    "badtextile",
    "pillowcase",
];

if (!(window as any).initPDP)
{
    (window as any).initPDP = true;
    document.addEventListener("DOMContentLoaded", () =>
    {
        if ($(".js-pdp-replacement").length > 0)
        {
            initStickyBar(null, null);
            initUspLabels();
            sendLastViewedProduct();
        }
    });
}

const initUspLabels = () =>
{
    if ($(".c-product-description__intro .c-product-description__text .js-usp-label").length > 0)
    {
        $(".c-product-description__intro").each((index, element) =>
        {
            $(element).find(".js-usp-label").appendTo($(element).find(".c-product-description__media"));
        });
    }
}

function initProductSelectionPopup(): void
{
    const elements = document.querySelectorAll<HTMLElement>(
        ".js-product-change-selection"
    );

    const initializedSources = new Set<SelectionSource>();

    elements.forEach((element) =>
    {
        const source = getSelectionSource(element);

        if (element.getAttribute("name") === "property5" && window.innerWidth > 768)
        {
            element.onchange = () => changeSelection(source);
            return;
        };

        const identifier = $(element).closest(".js-pdp-property-identifier").attr("id");

        if (!source || initializedSources.has(source))
            return;

        initializedSources.add(source);

        const popup = createSelectionPopup(source, identifier);

        if (source instanceof HTMLSelectElement)
        {
            source.addEventListener("mousedown", (event) =>
            {
                // Voorkomt dat de native select opent.
                event.preventDefault();
            });

            source.addEventListener("click", (event) =>
            {
                event.preventDefault();
                event.stopPropagation();

                if (element.getAttribute("name") === "property3" || element.getAttribute("name") === "property3_mobile") {
                    openSelectionPopup(popup, source, false);
                }
                else if (!useColorPopup && isGridSource(source))
                {
                    changeSelection(source);
                }
                else
                {
                    openSelectionPopup(popup, source, false);
                }
            });

            source.addEventListener("change", (e) =>
            {
                changeSelection(source);
            });

            return;
        }

        source.addEventListener("click", (event) =>
        {
            const target = event.target;

            if (!(target instanceof Element))
            {
                return;
            }

            const clickedOption = target.closest<HTMLElement>(
                ".c-product-spec__option"
            );

            if (!clickedOption || !source.contains(clickedOption))
            {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            if (!useColorPopup && isGridSource(source))
            {
                changeSelection(clickedOption);
            }
            else
            {
                openSelectionPopup(popup, source, false);
            }
        });

        const imageUl = document.getElementsByClassName("product-gallery-item")[0].parentNode;
        const freestandingImage = imageUl.querySelector('[data-imagetype="vrijstaand"]');

        if (freestandingImage)
        {
            imageUl.removeChild(freestandingImage);
            imageUl.appendChild(freestandingImage);
        }
    });
}

const initSoldoutAlternativeButton = () =>
{
    const $button = $("#c-product-detail__alternative-button");
    const $productData = $(".js-article-data");

    if (!$button || !$productData)
        return;

    const category: string = $productData.data("category");
    const categoryName = getTranslations().categoryName[category];

    if (!categoryName)
        return;

    $button.text(getTranslations().txtSoldoutAlternativeButton.replace("{0}", categoryName[0]));
    $button.attr("href", `/${categoryName[1]}`);
}

function initBundleSelectionPopup(): void
{
    const elements = document.querySelectorAll<HTMLElement>(
        ".js-bundle-change-selection"
    );

    const initializedSources = new Set<SelectionSource>();

    elements.forEach((element) =>
    {
        const identifier = $(element).closest(".js-pdp-property-identifier").attr("id");
        const source = getSelectionSource(element);

        if (!source || initializedSources.has(source))
        {
            return;
        }

        initializedSources.add(source);

        const popup = createBundleSelectionPopup(source, identifier);

        if (source instanceof HTMLSelectElement)
        {
            source.addEventListener("mousedown", (event) =>
            {
                // Voorkomt dat de native select opent.
                event.preventDefault();
            });

            source.addEventListener("click", (event) =>
            {
                event.preventDefault();
                event.stopPropagation();

                openSelectionPopup(popup, source, true);
            });

            return;
        }

        source.addEventListener("click", (event) =>
        {
            const target = event.target;

            if (!(target instanceof Element))
            {
                return;
            }

            const clickedOption = target.closest<HTMLElement>(
                ".c-product-spec__option"
            );

            if (!clickedOption || !source.contains(clickedOption))
            {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            openSelectionPopup(popup, source, true);
        });
    });

    addBundleEvents();
}

function initBundlePackageSelectionPopup(): void
{
    const elements = document.querySelectorAll<HTMLElement>(
        ".c-product-detail__productbundle-product-item__alternative-container"
    );
    elements.forEach((element) =>
    {
        $(element).off("click").on("click", () =>
        {
            var id = $(element).data('id');
            var articleID = $(element).data('orgaid');
            var index = $(element).data('index');
            $.ajax({
                type: "POST",
                url: "/Services/Modules/Webshop.asmx/GetWebshopBundleArticle?aid=" + articleID + "&index=" + index,
                data: "{}",
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (data)
                {
                    var popupTemplate = data.d.PopupTemplate;

                    if (typeof (popupTemplate) !== typeof (undefined) &&
                        popupTemplate != null)
                    {
                        const source = $(popupTemplate).closest<HTMLSelectElement>(
                            ".c-product-spec__options"
                        )[0];

                        const sourceContent = $(popupTemplate).closest<HTMLSelectElement>(
                            ".js-bundle-change-selection-container"
                        )[0];

                        const popup = createSelectionPackagePopup(source, sourceContent, "alternative-popup");
                        const buttonList = [];
                        const btnShow = new PopupButton();
                        btnShow.className = "btn btn-green show-results full-width";
                        btnShow.label = "Selecteer alternatief";
                        btnShow.onClick = () =>
                        {
                            submitAlternativePackage();
                            popup.destroy();
                        };

                        buttonList.push(btnShow);
                        popup.buttons = buttonList;
                        openSelectionPopup(popup, source, true);
                        initLazyLoad();

                        // Select current item
                        var currentItem = `#featureditem-${id}`.replace('bundle', '');
                        if ($(currentItem).length > 0)
                            $(currentItem).trigger('click');
                    }
                }
            });
        });
    });
}

function initNoStockMessage(): void
{
    if ($("#stockstatus_lowstock").length > 0 &&
        $("#stockstatus_lowstock").val() === "1" &&
        $(".c-product-detail__lowstock-message").length <= 0
    )
        $("#stockstatus_lowstock").before(`<div class="c-product-detail__lowstock-message">${getTranslations().LowStockRemainingMessage}</div>`);
}

function initExpectedDeliveryCartButton(): void
{
    if ($("#stockstatus_hascurrentstock").length > 0 &&
        $("#stockstatus_hascurrentstock").val() == "0")
    {
        let shippingDate: string = $("#stockstatus_expectedshippingdate").val() as string;
        if (!shippingDate || shippingDate.length <= 0)
            shippingDate = $("#stockstatus_expecteddate").val() as string;

        //#region Check expected delivery date tomorrow

        const dutchMonths: string[] = [
            'januari', 'februari', 'maart', 'april', 'mei', 'juni',
            'juli', 'augustus', 'september', 'oktober', 'november', 'december'
        ];
        // Get day and month from the date. (Formats like '2 februari'.)
        const [dayStr, monthStr] = shippingDate.toLowerCase().split(' ');
        const day: number = parseInt(dayStr, 10);
        const monthIndex: number = dutchMonths.indexOf(monthStr);
        const currentYear: number = new Date().getFullYear();
        const checkDate: Date = new Date(currentYear, monthIndex, day);
        const tomorrowDate: Date = new Date();
        tomorrowDate.setDate(tomorrowDate.getDate() + 1); 
        checkDate.setHours(0, 0, 0, 0);
        tomorrowDate.setHours(0, 0, 0, 0);

        //#endregion Check expected delivery date tomorrow

        if (checkDate > tomorrowDate)
        {
            const shippingDateText = String.format(getTranslations().CartButtonExpectedDelivery, shippingDate);

            console.log(shippingDateText);

            $(".js-cart-add-article").text(shippingDateText);
        }
        else
        {
            $(".js-product-detail__soldout-text").addClass("hidden");
            $(".js-comparable-products-holder").addClass("hidden");
        }
    }
}

function createSelectPopupOptionsTest(
    select: HTMLSelectElement
): PopupContentOptions[]
{
    return Array.from(select.options)
        .filter((option) =>
        {
            return option.value !== "";
        })

        .map((option) =>
        {
            const popupOption = new PopupContentOptions(`popup-option-${select.name}-${option.value}`, option.selected);

            popupOption.name = select.name;
            popupOption.value = option.value;
            popupOption.text =
                option.textContent?.trim() ?? "";
            popupOption.disabled = option.disabled;

            return popupOption;
        });
}

function openSelectionPopup(
    popup: Popup,
    source: SelectionSource,
    customContent: boolean
): void
{
    window.setTimeout(() =>
    {
        popup.show();

        window.requestAnimationFrame(() =>
        {
            applyPopupLayoutClass(source, customContent);
        });
    }, 0);
}

function applyPopupLayoutClass(
    source: SelectionSource,
    customContent: boolean
): void
{
    const visiblePopup = document.querySelector<HTMLElement>(
        ".g-popup--visible"
    );

    if (!visiblePopup)
    {
        return;
    }

    const contentHolderInner =
        visiblePopup.querySelector<HTMLElement>(
            ".g-popup__contentholder-inner"
        );

    if (!contentHolderInner)
    {
        return;
    }

    if (!customContent)
    {
        const isGrid = isGridSource(source);

        contentHolderInner.classList.toggle(
            "g-popup__contentholder-inner--grid",
            isGrid
        );

        contentHolderInner.classList.toggle(
            "g-popup__contentholder-inner--list",
            !isGrid
        );
    }
}

function getSelectionSource(
    element: HTMLElement
): SelectionSource | null
{
    if (element instanceof HTMLSelectElement)
    {
        return element;
    }

    return element.closest<HTMLElement>(
        ".c-product-spec__options"
    );
}

function createSelectionPopup(
    source: SelectionSource,
    id: string
): Popup
{
    const popup = new Popup({
        id: id,
        title: getPopupTitle(source),
        content: OPTIONS.includes(getOptionsName(source)) ? createPopupContent(source) : createPopupOptions(source),
        grid: isGridSource(source),

        mobilePosition: PopupPosition.Drawer,
        desktopPosition: PopupPosition.Right,
        closeButton: true,

        onChange: (event: Event) =>
        {
            const target = event.target;

            if (!(target instanceof HTMLInputElement))
            {
                return;
            }

            if (source instanceof HTMLSelectElement)
            {
                updateSelectSelection(
                    source,
                    target.value
                );
            }
            else
            {
                updateColorSelection(
                    source,
                    target.value
                );
            }

            popup.hide();
        }
    });

    return popup;
}

function createBundleSelectionPopup(
    source: SelectionSource,
    id: string
): Popup
{
    const popup = new Popup({
        id: id,
        title: getPopupTitle(source),
        content: OPTIONS.includes(getOptionsName(source)) ? createPopupContent(source) : createPopupOptions(source),
        popupClass: "g-popup__container--w-480, g-popup__container--px-4-mobile, g-popup__container--mh-mobile",
        grid: isGridSource(source),

        mobilePosition: PopupPosition.Drawer,
        desktopPosition: PopupPosition.Right,
        closeButton: true,

        onChange: (event: Event) =>
        {
            const target = event.target;

            if (!(target instanceof HTMLInputElement))
            {
                return;
            }

            if (source instanceof HTMLSelectElement)
            {
                updateSelectSelection(
                    source,
                    target.value
                );
            }
            else
            {
                updateColorSelection(
                    source,
                    target.value
                );
            }

            popup.hide();
        }
    });

    return popup;
}

function createSelectionPackagePopup(
    source: SelectionSource,
    sourceContent: SelectionSource,
    id: string,
): Popup
{
    const popup = new Popup({
        id: id,
        title: getPopupTitle(source),
        content: createPackagePopupContent(sourceContent),
        popupClass: "g-popup__container--w-480",
        grid: isGridSource(source),

        mobilePosition: PopupPosition.Drawer,
        desktopPosition: PopupPosition.Right,
        closeButton: true,

        onChange: (event: Event) =>
        {
            const target = event.target;

            if (!(target instanceof HTMLInputElement))
            {
                return;
            }

            if (source instanceof HTMLSelectElement)
            {
                updateSelectSelection(
                    source,
                    target.value
                );
            }
            else
            {
                updateColorSelection(
                    source,
                    target.value
                );
            }

            popup.hide();
        }
    });

    return popup;
}

function getPropertyName(
    source: SelectionSource
): string
{
    if (source instanceof HTMLSelectElement)
    {
        return source.name;
    }

    const option = source.querySelector<HTMLElement>(
        ".c-product-spec__option[data-name]"
    );

    return option?.dataset.name ?? "";
}

function getOptionsName(
    source: SelectionSource
): string
{
    return source?.dataset.name ?? "";
}

function isGridSource(
    source: SelectionSource
): boolean
{
    const propertyName = getPropertyName(source);

    return GRID_PROPERTIES.includes(propertyName);
}

function createPopupOptions(
    source: SelectionSource
): PopupContentOptions[]
{
    if (source instanceof HTMLSelectElement)
    {
        return createSelectPopupOptions(source);
    }

    return createColorPopupOptions(source);
}

function createPopupContent(
    source: SelectionSource
): PopupContent[]
{
    if (OPTIONS.includes(getOptionsName(source)))
    {
        return createBundlePopupContent(source);
    }

    return createBundlePopupContent(source);
}

function createSelectPopupOptions(
    select: HTMLSelectElement
): PopupContentOptions[]
{
    return Array.from(select.options)
        .filter((option) =>
        {
            return option.value !== "";
        })

        .map((option) =>
        {
            const popupOption = new PopupContentOptions(`popup-option-${select.name}-${option.value}`, option.selected);

            popupOption.name = select.name;
            popupOption.value = option.value;
            popupOption.text =
                option.textContent?.trim() ?? "";
            popupOption.disabled = option.disabled;
            popupOption.image = option.getAttribute("data-image") ?? "";

            return popupOption;
        });
}

function createColorPopupOptions(
    optionsWrapper: HTMLElement
): PopupContentOptions[]
{
    const colorOptions =
        optionsWrapper.querySelectorAll<HTMLElement>(
            ".c-product-spec__option"
        );

    return Array.from(colorOptions).map(
        (colorOption) =>
        {
            const name = colorOption.dataset.name ?? "product-option";
            const value = colorOption.dataset.value ?? "";
            const text = colorOption.querySelector<HTMLElement>(".c-product-spec__option-name")?.textContent?.trim() ?? "";
            const image = colorOption.querySelector<HTMLImageElement>(".c-product-spec__option-image")?.src;
            const popupOption = new PopupContentOptions(`popup-option-${name}-${value}`, colorOption.classList.contains("selected"));

            popupOption.name = name;
            popupOption.value = value;
            popupOption.text = text;
            popupOption.image = image;
            popupOption.disabled = colorOption.classList.contains("soldout") || colorOption.classList.contains("disabled");

            return popupOption;
        }
    );
}

function createBundlePopupContent(
    optionsWrapper: HTMLElement
): PopupContent[]
{
    const bundleOptions =
        optionsWrapper.querySelectorAll<HTMLElement>(
            ".c-product-spec__option"
        );

    var bundleContent = document.createElement("div");
    bundleContent.className = "c-popup__card-holder";

    const bundleTemplate =
        optionsWrapper.querySelectorAll<HTMLElement>(
            ".js-popup__bundle--content"
        );

    const itemEl = document.createElement("div");
    itemEl.className = "c-popup__card-holder";
    for (let bundleElements of Array.from(bundleTemplate))
    {
        itemEl.appendChild(bundleElements);
    }

    const popupContent = [];
    const popupOption = new PopupContent();
    popupOption.content = itemEl;

    popupContent.push(popupOption);

    return popupContent;
}

function createPackagePopupContent(
    optionsWrapper: HTMLElement
): PopupContent[]
{
    const bundleOptions =
        optionsWrapper.querySelectorAll<HTMLElement>(
            ".js-bundle-change-selection"
        );

    const itemEl = document.createElement("div");
    itemEl.className = "c-popup__card-holder";
    itemEl.appendChild(bundleOptions[0]);

    const popupContent = [];
    const popupOption = new PopupContent();
    popupOption.content = itemEl;

    popupContent.push(popupOption);

    return popupContent;
}

function updateSelectSelection(
    select: HTMLSelectElement,
    value: string
): void
{
    select.value = value;

    select.dispatchEvent(
        new Event("change", {
            bubbles: true
        })
    );
}

function updateColorSelection(
    optionsWrapper: HTMLElement,
    value: string
): void
{
    const originalOption =
        optionsWrapper.querySelector<HTMLElement>(
            `.c-product-spec__option[data-value="${CSS.escape(value)}"]`
        );

    if (!originalOption)
    {
        return;
    }

    originalOption.click();
}

function getPopupTitle(
    source: SelectionSource
): string
{
    if (getPropertyName(source) === "property9")
        return getTranslations().SelectMaterialTxt;

    if (getPropertyName(source) === "property3")
        return getTranslations().SelectColorTxt;

    if (getOptionsName(source) === "sheet")
        return getTranslations().SelectBottomSheetTxt;

    if (source instanceof HTMLSelectElement)
    {
        if (!source.id)
            return getTranslations().MakeChoicePopupTitle;

        const label =
            document.querySelector<HTMLLabelElement>(
                `label[for="${CSS.escape(source.id)}"]`
            );

        return (
            label?.textContent?.trim() ??
            source.getAttribute("for") ??
            getTranslations().MakeChoicePopupTitle
        );
    }

    return getTranslations().MakeChoicePopupTitle;
}

(window as any).addBundleItemToCart = addBundleItemToCart;
(window as any).removeBundleItemToCart = removeBundleItemToCart;
(window as any).changeBundleArticleProperty = changeBundleArticleProperty;
(window as any).addPackageBundleToCart = addPackageBundleToCart;
(window as any).updatePackageBundle = updatePackageBundle;
(window as any).selectAlternativePackage = selectAlternativePackage;

/* #region bundles */

function updatePackageBundle(source, index)
{
    // hide/show info text associated
    var infoText = $(`#packagebundle-${index}`);
    if ($(infoText).length > 0)
    {
        if (!$(infoText).parent().hasClass('c-product-detail__productbundleinfo-item--hide'))
            $(infoText).parent().addClass("c-product-detail__productbundleinfo-item--hide");
        else
            $(infoText).parent().removeClass("c-product-detail__productbundleinfo-item--hide");
    }

    recalculatePackageBundle();
}

function recalculatePackageBundle()
{
    // Recalculate totalprice
    var totalValue = 0;
    $('.c-product-detail__productbundle-products .c-product-detail__productbundle-product-item').each(function (index, item)
    {
        if ($(item).find('.c-product-detail__productbundle-product-item-checkbox:checked').length > 0)
        {
            var price = $(item).data('price');
            var quantity = $(item).data('quantity');
            totalValue += quantity * price;
        }
    });

    $('#c-product-detail__productbundle-totalprice').html(totalValue.toFixed(2).replace(".", ","));
}

let bundleTitle;

function addBundleItemToCart(source, id)
{
    const aid = $(source).data("articleid");
    addArticleToCart(source, aid, true, false, true, false, false);

    if ($(source).parent().hasClass("c-product-spec__addbutton"))
    {
        $(source).parent().hide();
        var amountContainer = $(source).parents(".c-product-spec__amount").find(".c-product-spec__amountcontainer");
        var amountContainerValue = $(amountContainer).find(".c-product-spec__quantity");

        $(amountContainer).removeClass("hidden");
        var amount = $(amountContainerValue).val();
        $(amountContainerValue).val(Number(amount) + 1);
    }
    else
    {
        var amountContainerValue = $(source).parent(".c-product-spec__amountcontainer").find(".c-product-spec__quantity");
        var amount = $(amountContainerValue).val();
        $(amountContainerValue).val(Number(amount) + 1);
    }

    const buttonContent = document.createElement("div");
    buttonContent.classList.add("c-product-spec__button-content")
    
    if ($(".c-product-spec__button").find(".c-product-spec__button-content").length === 0)
      bundleTitle = document.querySelector(".c-product-spec__button").innerHTML;

    const itemName = $(source).parents(".c-product-spec__info").find(".c-product-spec__productname")[0].innerText;

    const crossDiv = document.createElement("div");
    crossDiv.classList.add("c-product-spec__button-cross");

    const itemImg = $(source).parents(".js-popup__bundle--content-featuredcombi").find(".product-block").find("img").clone()[0];
    itemImg.classList.add("c-product-spec__button-img")

    const bundleButton = document.querySelector(".c-product-spec__button");

    const nameDiv = document.createElement("div");
    nameDiv.classList.add("c-product-spec__button-text");
    nameDiv.innerText = itemName;

    buttonContent.append(crossDiv);
    buttonContent.append(itemImg);
    buttonContent.append(nameDiv);

    if (bundleButton)
    {
        bundleButton.innerHTML = "";
        bundleButton.append(buttonContent);
    }

    setTimeout(() =>
    {
        loadCart();
    }, 300);
}

function removeBundleItemToCart(source, id)
{
    var articleID = $(source).closest(".js-order-line").data("articleid");
    if (typeof (undefined) == typeof (articleID))
        articleID = $(source).data("articleid");

    const quantity = parseInt($(source).parent().find(".c-product-spec__quantity").val() as string) - 1;

    updateCartQuantity(articleID, quantity, $(source).closest(".js-order-line")[0], false);

    var addButton = $(source).parent('.c-product-spec__amountcontainer').parent('.c-product-spec__amount').find('.c-product-spec__addbutton');
    var amountContainer = $(source).parent('.c-product-spec__amountcontainer');

    if (quantity === 0)
    {
        $(addButton).show();
        $(amountContainer).addClass("hidden");
    }

    var amountContainerValue = $(source).parent('.c-product-spec__amountcontainer ').find('.c-product-spec__quantity');
    $(amountContainerValue).val(quantity);

    if (quantity <= 0)
        $(".c-product-spec__button")[0].innerHTML = bundleTitle;

    setTimeout(() =>
    {
        loadCart();
    }, 300);
}

function addBundleEvents()
{
    addCombiBundleEvents(null);
    setBundleMattressThicknessChange(null, null);
}

function addCombiBundleEvents(customBundleElement)
{
    if (!customBundleElement ||
        $(customBundleElement).length == 0
    )
        customBundleElement = ".combibundles";

    if ($(customBundleElement).length > 0)
    {
        $(customBundleElement).find(".js-popup__bundle--content-inner .js-popup__bundle--content-featuredcombi").off("click").on("click", handleBundleItemClick);

        setTimeout(function ()
        {
            if ($(customBundleElement).find(".custom-select-item-wrapper .nativejs-select__dropdown button").length > 0)
            {
                $(customBundleElement).find(".custom-select-item-wrapper .nativejs-select__dropdown button").off("click").on("click", function ()
                {
                    var text = $(this)
                        .text()
                        .replaceAll("\n", "")
                        .trim();

                    sendDataLayer({
                        "event": "Click",
                        "category": "Navigatie",
                        "action": "Bijpassende hoeslaken",
                        "label": text
                    });
                });
            }
        }, 1);

        if ($(customBundleElement).find(".js-popup__bundle--content-inner").length > 0)
        {
            onScrolledIntoView($(customBundleElement).find(".js-popup__bundle--content-inner"), function ()
            {
                var bundleBlock = $(customBundleElement).find(".js-popup__bundle--content-inner");

                sendDataLayer({ ecommerce: null }); // Clear the previous ecommerce object.

                var items = [];
                var breadcrumbs = getBreadCrumbImpression();

                bundleBlock.find(".js-popup__bundle--content-featuredcombi").each(function (index, element)
                {
                    var combiItem = $(element);
                    var name = combiItem.attr("data-name");
                    var sku = combiItem.attr("data-sku");
                    var price = combiItem.attr("data-price");
                    var discount = combiItem.attr("data-discount");
                    var brand = combiItem.attr("data-brand");
                    var category = combiItem.attr("data-category");
                    var color = combiItem.attr("data-color");
                    var variant = combiItem.attr("data-variant");
                    var size = combiItem.attr("data-size");
                    var livingstyle = combiItem.attr("data-livingstyle");
                    var priceclass = combiItem.attr("data-priceclass");
                    var position = combiItem.attr("data-position");
                    var material = combiItem.attr("data-material");
                    var stuffing = combiItem.attr("data-stuffing");
                    var season = combiItem.attr("data-season");
                    var deliverytime = combiItem.attr("data-deliverytime");
                    var articlenumber = combiItem.attr("data-articlenumber");
                    var sleepingposition = combiItem.attr("data-sleepingposition");
                    var firmness = combiItem.attr("data-firmness");
                    var stock = combiItem.attr("data-stock");
                    var type = combiItem.attr("data-type");
                    var thermalclass = combiItem.attr("data-thermalclass");

                    var item = {};
                    if (name != '')
                        item['item_name'] = name;
                    if (sku != '')
                        item['item_id'] = sku;
                    if (price != '')
                        item['price'] = price;
                    if (discount != '')
                        item['discount'] = discount;
                    item['currency'] = 'EUR';
                    if (brand != '')
                        item['item_brand'] = brand;
                    if (category != '')
                        item['item_category'] = category;
                    if (breadcrumbs['item3'] != '')
                        item['item_category2'] = breadcrumbs['item3'];
                    if (breadcrumbs['item4'] != '')
                        item['item_category3'] = breadcrumbs['item4'];
                    if (breadcrumbs['item5'] != '')
                        item['item_category4'] = breadcrumbs['item5'];
                    if (breadcrumbs['item6'] != '')
                        item['item_category5'] = breadcrumbs['item6'];
                    if (variant != '')
                        item['item_variant'] = variant;
                    if (color != '')
                        item['item_color'] = color;
                    if (size != '')
                        item['item_size'] = size;
                    if (livingstyle != '')
                        item['item_woonstijl'] = livingstyle;
                    if (priceclass != '')
                        item['item_prijsklasse'] = priceclass;
                    if (material != '')
                        item['item_materiaal'] = material;
                    if (stuffing != '')
                        item['item_vulling'] = stuffing;
                    if (season != '')
                        item['item_seizoen'] = season;
                    if (deliverytime != '')
                        item['item_levertijd'] = deliverytime;
                    if (articlenumber != '')
                        item['item_smulcode'] = articlenumber;
                    if (sleepingposition != '')
                        item['item_slaaphouding'] = sleepingposition;
                    if (firmness != '')
                        item['item_stevigheid'] = firmness;
                    if (stock != '')
                        item['item_voorraad'] = stock;
                    if (type != '')
                        item['item_type'] = type;
                    if (thermalclass != '')
                        item['item_warmteklasse'] = thermalclass;
                    item['item_list_id'] = '1';
                    item['item_list_name'] = getBundleBlockListName();
                    if (position != '')
                        item['index'] = position;
                    item['quantity'] = '1';
                    item['google_business_vertical'] = 'retail';

                    items.push(item);
                });

                sendDataLayer({
                    'event': 'productView',
                    'category': 'Ecommerce',
                    'action': getBundleBlockListName(),
                    'label': bundleBlock.find("a").attr("href"),
                    'ecommerce': {
                        'items': items
                    }
                });
            });
        }
    }
}

function getBreadCrumbImpression()
{
    var breadcrumbholder = $('.breadcrumbs-holder div a');

    var breadcrumbs = {};
    breadcrumbs['item1'] = 'Home';
    breadcrumbs['item2'] = '';
    breadcrumbs['item3'] = '';
    breadcrumbs['item4'] = '';
    breadcrumbs['item5'] = '';
    breadcrumbs['item6'] = '';

    if (breadcrumbholder.length > 0)
    {
        var i = 1;
        breadcrumbholder.each(function ()
        {
            var breadcrumbTitle = $(this).attr('title');
            if (typeof (breadcrumbTitle) !== 'undefined' && breadcrumbTitle != null && breadcrumbTitle != '')
            {
                breadcrumbs['item' + i] = breadcrumbTitle;
                i++;
            }
        });
    }

    return breadcrumbs;
}

function getBundleBlockListName()
{
    var listName = "Bijpassende hoeslakens";

    if ($(".product-bundles.combibundles").data("name"))
        listName = $(".product-bundles.combibundles").data("name");

    return listName;
}

function handleBundleItemClick()
{
    if (!$.stash.exists("bundleClickedItem") ||
        typeof ($.stash.get("bundleClickedItem")) === typeof (undefined)
    )
        $.stash.set("bundleClickedItem", $(this).attr("data-aid"));

    var breadcrumbs = getBreadCrumbImpression();
    var name = $(this).attr("data-name");
    var sku = $(this).attr("data-sku");
    var price = $(this).attr("data-price");
    var discount = $(this).attr("data-discount");
    var brand = $(this).attr("data-brand");
    var category = $(this).attr("data-category");
    var color = $(this).attr("data-color");
    var variant = $(this).attr("data-variant");
    var size = $(this).attr("data-size");
    var livingstyle = $(this).attr("data-livingstyle");
    var priceclass = $(this).attr("data-priceclass");
    var position = $(this).attr("data-position");
    var material = $(this).attr("data-material");
    var stuffing = $(this).attr("data-stuffing");
    var season = $(this).attr("data-season");
    var deliverytime = $(this).attr("data-deliverytime");
    var articlenumber = $(this).attr("data-articlenumber");
    var sleepingposition = $(this).attr("data-sleepingposition");
    var firmness = $(this).attr("data-firmness");
    var stock = $(this).attr("data-stock");
    var type = $(this).attr("data-type");
    var thermalclass = $(this).attr("data-thermalclass");

    var breadcrumbs = getBreadCrumbImpression();
    var items = {};
    if (name != '')
        items['item_name'] = name;
    if (sku != '')
        items['item_id'] = sku;
    if (price != '')
        items['price'] = price;
    if (discount != '')
        items['discount'] = discount;
    items['currency'] = 'EUR';
    if (brand != '')
        items['item_brand'] = brand;
    if (category != '')
        items['item_category'] = category;
    if (breadcrumbs['item3'] != '')
        items['item_category2'] = breadcrumbs['item3'];
    if (breadcrumbs['item4'] != '')
        items['item_category3'] = breadcrumbs['item4'];
    if (breadcrumbs['item5'] != '')
        items['item_category4'] = breadcrumbs['item5'];
    if (breadcrumbs['item6'] != '')
        items['item_category5'] = breadcrumbs['item6'];
    if (variant != '')
        items['item_variant'] = variant;
    if (color != '')
        items['item_color'] = color;
    if (size != '')
        items['item_size'] = size;
    if (livingstyle != '')
        items['item_woonstijl'] = livingstyle;
    if (priceclass != '')
        items['item_prijsklasse'] = priceclass;
    if (material != '')
        items['item_materiaal'] = material;
    if (stuffing != '')
        items['item_vulling'] = stuffing;
    if (season != '')
        items['item_seizoen'] = season;
    if (deliverytime != '')
        items['item_levertijd'] = deliverytime;
    if (articlenumber != '')
        items['item_smulcode'] = articlenumber;
    if (sleepingposition != '')
        items['item_slaaphouding'] = sleepingposition;
    if (firmness != '')
        items['item_stevigheid'] = firmness;
    if (stock != '')
        items['item_voorraad'] = stock;
    if (type != '')
        items['item_type'] = type;
    if (thermalclass != '')
        items['item_warmteklasse'] = thermalclass;
    items['item_list_id'] = '1';
    items['item_list_name'] = getBundleBlockListName();
    if (position != '')
        items['index'] = position;
    items['quantity'] = '1';
    items['google_business_vertical'] = 'retail';

    sendDataLayer({ ecommerce: null }); // Clear the previous ecommerce object.
    sendDataLayer({
        'event': 'productClick',
        'category': 'Ecommerce',
        'action': getBundleBlockListName(),
        'label': $(this).find("a").attr("href"),
        'ecommerce': {
            'items': [items]
        }
    });
}

function setBundleMattressThicknessChange(selectorName, bundleType)
{
    if (!selectorName)
        selectorName = "matrasthickness";

    if (!bundleType)
        bundleType = 0;

    $(`#${selectorName}`).off("change").on("change", function ()
    {
        var id = $("#shopid").val(); // productid
        var artid = $("#shopart").val(); // articleid
        var selectedValue = $(`select[name^='${selectorName}']`).val();
        var selectedElement = $(`select[name^='${selectorName}'] option[value=${selectedValue}]`);
        var combiBundleElement = $(`#${selectorName}`).closest(".product-bundles");
        var isCart = false;

        if (typeof (id) == typeof (undefined))
        {
            id = $(combiBundleElement).data('pid');
            isCart = true;

            bundleType = 2;
        }

        if (typeof (artid) == typeof (undefined))
            artid = $(combiBundleElement).data('aid');

        if (selectedElement.length > 0)
        {
            var searchnameID = $(selectedElement).attr('data-searchname');;
            var articleGroupID = $(selectedElement).attr("data-group");
            $.get("/Services/Modules/Webshop.asmx/ShowBundleSale?searchnameid=" + searchnameID +
                "&artgroupsearchnameid=" + articleGroupID +
                "&shopid=" + id +
                "&shopart=" + artid +
                "&bundletype=" + bundleType,
                function (data)
                {
                    if ($(data).find(".product-bundles-inner").length > 0)
                    {
                        // Remember selection for later
                        $.stash.set('curMatrasSearchnameGroup', searchnameID);
                        $.stash.set('curMatrasArticleGroup', articleGroupID);

                        $(combiBundleElement).find(".product-bundles-inner").replaceWith($(data).find(".product-bundles-inner")[0].outerHTML);

                        initLazyLoad();

                        if (!isCart)
                            initBundleEvents(combiBundleElement);
                    }
                });
        }
    });
}

function changeBundleArticleProperty(source)
{
    if (typeof (source) == typeof (undefined) && source == null)
        return false;

    var articleContainer = $(source).parents('.js-popup__bundle--content-featuredcombi');

    if (typeof (articleContainer) == typeof (undefined) && articleContainer == null)
        return false;

    var aid = $(articleContainer).data('aid');
    var pid = $(articleContainer).data('pid');
    var propertyID = $(source).attr('name').replace('property', '')
    var optionID = $(source).find('option:selected').val()
    var combiBundleTypeName = '';

    var url = "/Services/Modules/Webshop.asmx/ShowCartPopupForArticle?shopid=" + pid +
        "&aid=" + aid +
        "&lastSel=" + propertyID +
        "&property" + propertyID + "=" + optionID +
        "&property=" + propertyID +
        "&quantity=" + 1;

    if (combiBundleTypeName.length > 0)
        url += "&bundletypename=" + combiBundleTypeName;

    $.ajax({
        type: "POST",
        url: url,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        error: function (jqXHR, textStatus, errorThrown)
        {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        },
        success: function (data)
        {
            var articleID = data.d.ArticleID;
            var articlePrice = String(data.d.ArticlePrice).replace(".", ",");

            $(articleContainer).find('.c-product-spec__addbutton button').attr("data-articleid", articleID);

            $(articleContainer).find('.c-product-spec__amountremove').attr("data-articleid", articleID);
            $(articleContainer).find('.c-product-spec__amountadd').attr("data-articleid", articleID);

            $(articleContainer).find('.c-product-spec__price').html(articlePrice);
        }
    });
}

function initBundleEvents(customBundleElement)
{
    // addCombiBundleEvents(customBundleElement);

    var bundleInner = $("#main .product-bundles-inner");
    if (customBundleElement &&
        $(customBundleElement).length > 0
    )
        bundleInner = $(customBundleElement).find(".product-bundles-inner");

    if ($(bundleInner).length > 0)
    {
        $(bundleInner).find(".bundle-product-amount .amount-less").off("click").on("click", function ()
        {
            $($(this).parent()).find("input").trigger("change");
        });

        $(bundleInner).find(".bundle-product-amount .amount-more").off("click").on("click", function ()
        {
            $($(this).parent()).find("input").trigger("change");
        });

        $(bundleInner).find(".bundle-product-amount input").off("change").on("change", function ()
        {
            var parentBlock = $(this).closest(".product-bundles");

            // Loop all inputs to ensure all product quantities are up-to-date.
            $($(parentBlock).find(".bundle-product-amount input")).each(function (index, item)
            {
                var articleID = $(item).data("articleid");
                var value = $(item).val();

                var articleItem = $(parentBlock).find(".product-bundles-product-item[data-articleid='" + articleID + "']");

                // Update quantity.
                $(articleItem).data("quantity", value);
                $(articleItem).attr("data-quantity", value.toString());
            });

            // Check if any of the products has any quantity.
            var anyHasQuantity = false;

            $(parentBlock).find(".product-bundles-product-item").each(function (index, item)
            {
                var itemQuantity = $(this).data("quantity");

                if (typeof (itemQuantity) !== typeof (undefined) &&
                    itemQuantity != null &&
                    itemQuantity > 0)
                {
                    // Current product has a quantity above 0.
                    anyHasQuantity = true;
                    return false;
                }
            });

            // Enable button if any product has a quantity above 0. Otherwise, disable the button.
            if (anyHasQuantity)
                $(parentBlock).find(".add-cart-button").removeClass("disabled");
            else
                $(parentBlock).find(".add-cart-button").addClass("disabled");
        });
    }

    // Disable add to cart button for bundle if no articles are selected for bundle
    $('.product-bundles-inner').off("click").on('click', function (index, item)
    {
        var toggleEnabled = $('#main.enable-bundle-checkboxes');

        if (toggleEnabled.length > 0)
        {
            var addToCartBtn = $(this).find('.add-cart-button');
            if (addToCartBtn.length > 0)
            {
                if ($(".customchbox:visible input[class^='bundle']:checked").length > 0)
                    $(addToCartBtn).removeAttr('disabled');
                else
                    $(addToCartBtn).attr('disabled', 'true');
            }
        }
    });
}

function addPackageBundleToCart()
{
    var $products = $('.c-product-detail__productbundle-products .c-product-detail__productbundle-product-item');
    var ajaxPostData = [];

    $products.each(function (index, item)
    {
        if ($(item).find('.c-product-detail__productbundle-product-item-checkbox:checked').length > 0)
        {
            var articleID = $(item).data("articleid");
            var productID = $(item).data("productid");
            var quantity = $(item).data("quantity");
            var jsEncodedName = $(item).data("name");
            var sku = $(item).data("sku");
            var price = $(item).data("price");
            var brand = $(item).data("brand");
            var categoryTree = $(item).data("category");
            var jsVariant = $(item).data("variant");

            ajaxPostData.push({ articleid: articleID, productid: productID, quantity: quantity });

            sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
            sendDataLayer({
                'ecommerce': {
                    'detail': {
                        'actionField': { 'list': '' },    // 'detail' actions have an optional list property.
                        'products': [{
                            'name': jsEncodedName,         // Name or ID is required.
                            'id': sku,
                            'price': price,
                            'brand': brand,
                            'category': categoryTree,
                            'variant': jsVariant,
                            'quantity': quantity
                        }]
                    }
                }
            });

            addArticleToCart($(this), articleID, shopConfig().useAddToCartPopup, false, true, false, false);
        }
    });

    if (ajaxPostData.length > 0)
    {
        setTimeout(() =>
        {
            loadCart();
        }, 300);
    }

    $.ajax({
        type: "POST",
        url: "/Services/Modules/Webshop.asmx/AddArticleListToCart",
        data: JSON.stringify({ 'articles': ajaxPostData, 'returnProduct': true }),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        error: function (jqXHR, textStatus, errorThrown)
        {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        },
        success: function (data)
        {
            var combinedTemplate = '';

            $(data.d).each(function (index, item)
            {
                combinedTemplate += $(item.ProductDetail).filter('.w-productlist').html();
            });

            const buttons = [];

            const btnClose = new PopupButton();
            btnClose.className = "btn btn-arrow-left btn-blue show-desktop";
            btnClose.label = getTranslations().txtContinueShopping;
            btnClose.closeOnCLick = true;
            buttons.push(btnClose);

            const btnCloseMobile = new PopupButton();
            btnCloseMobile.className = "btn btn-arrow-right btn-blue-link show-mobile";
            btnCloseMobile.label = getTranslations().txtContinueShopping;
            btnCloseMobile.closeOnCLick = true;
            buttons.push(btnCloseMobile);

            const btnCart = new PopupButton();
            btnCart.className = "btn btn-arrow-right btn-green";
            btnCart.label = getTranslations().txtToShoppingCart;
            btnCart.onClick = () =>
            {
                location.href = getTranslations().shoppingCartUrlLowerCaseTxt;
                return;
            };
            buttons.push(btnCart);

            const addToCartPopupBundle = new Popup({
                id: "bundle-popup",
                popupClass: "g-popup__buttons--space-between",
                title: getTranslations().cartHeaderText,
                desktopPosition: PopupPosition.Center,
                mobilePosition: PopupPosition.Drawer,
                content: combinedTemplate,
                headerIcon: "ic-check-aft cl-gd2-aft-bg",
                closeButton: true,
                buttons: buttons
            });

            addToCartPopupBundle.show();
        }
    });

    sendDataLayer({
        'event': 'Click',
        'category': 'Ecommerce',
        'action': 'Bundel verkoop',
        'label': window.location.href
    });

    sendDataLayer({ 'event': 'basketadd' });
}

function selectAlternativePackage(source)
{
    var container = $(source).parent();
    $(container).find('.js-popup__bundle--content-featuredcombi').removeClass("js-popup__bundle--content-featuredcombi-selected");
    $(source).addClass("js-popup__bundle--content-featuredcombi-selected");
}

function submitAlternativePackage()
{
    // Check if a selection was made
    if ($('.js-popup__bundle--content .js-popup__bundle--content-featuredcombi-selected').length)
    {
        var selectedItem = $('.js-popup__bundle--content .js-popup__bundle--content-featuredcombi-selected').first();

        var aid = $(selectedItem).data("aid");
        var brand = $(selectedItem).data("brand");
        var name = $(selectedItem).data("productname");
        var photo = $(selectedItem).data("photo");
        var price = $(selectedItem).data("price");
        var quantity = $(selectedItem).data("quantity");
        var index = $(selectedItem).data("index");

        var overviewItem = $(`.c-product-detail__productbundle-product-item[data-index=${index}]`);
        if ($(overviewItem).length > 0)
        {
            $(overviewItem).find('.c-product-detail__productbundle-product-item__data img').attr("src", photo);
            $(overviewItem).find('.c-product-detail__productbundle-product-item__brand').html(brand);
            $(overviewItem).find('.c-product-detail__productbundle-product-item__name').html(name);
            $(overviewItem).find('.c-product-detail__productbundle-product-item__price').html(price);

            $(overviewItem).data("articleid", aid);
            $(overviewItem).data("price", price.replace(",", "."));

            // Update currently selected id
            $(overviewItem).find('.c-product-detail__productbundle-product-item__alternative-container ').data('id', aid);

            $(`#packagebundle-${index}`).html(`${quantity}x ${name}`);

            recalculatePackageBundle();
        }
    }
}

/* #endregion bundles */

function loadInstagramPosts()
{
    const $wrapper = $(".product-media-wrapper");

    if ($wrapper.length === 0)
        return;

    const wrapper = $wrapper.get(0);

    if (!wrapper)
        return;

    const observer = new IntersectionObserver((entries) =>
    {
        const entry = entries[0];

        if (!entry.isIntersecting)
            return;

        observer.disconnect();

        var successCallback = function (data)
        {
            if (data !== null && typeof (data) !== typeof (undefined) && data?.length > 0)
            {
                $wrapper.html(data);
            }
            else
            {
                $wrapper.remove();
            }
        };

        if (shopConfig().api.active)
        {
            var body = {
                productId: $("#shopid").val(),
                articleId: $("#shopart").val()
            };

            sendApiCall({
                endpoint: "/WebshopProductMedia/get-product-media",
                rawUrl: location.pathname,
                callback: successCallback,
                customDto: body,
                errorCallback: errorInstagramPost,
            });
        }
        else
        {
            $.ajax({
                type: "GET",
                url: "/Services/Modules/Webshop.asmx/GetProductMedia?productid=" +
                    $("#shopid").val() +
                    "&articleid=" +
                    $("#shopart").val(),
                success: successCallback,
                error: errorInstagramPost,
            });
        }
    });

    observer.observe(wrapper);
}

const errorInstagramPost = () =>
{
    const instaElement = document.getElementsByClassName("product-media-wrapper")[0] as HTMLDivElement;

    if (instaElement)
    {
        instaElement.remove();
    }
}

loadInstagramPosts();

type ProductLightboxState = {
    zoom: number;
};

type UIkitLightboxPanel = {
    show?: (index: number) => void;
};

type UIkitGlobal = {
    getComponent: (element: Element, component: string) => UIkitLightboxPanel | null;
};

const PRODUCT_LIGHTBOX_MIN_ZOOM = 1;
const PRODUCT_LIGHTBOX_MAX_ZOOM = 2.5;
const PRODUCT_LIGHTBOX_ZOOM_STEP = 0.25;

const productLightboxState: ProductLightboxState = {
    zoom: PRODUCT_LIGHTBOX_MIN_ZOOM,
};

function getProductLightbox(): HTMLElement | null
{
    return document.querySelector<HTMLElement>(".uk-lightbox");
}

function getOriginalGalleryLinks(): HTMLAnchorElement[]
{
    return Array.from(
        document.querySelectorAll<HTMLAnchorElement>(
            ".c-product-detail__gallery .product-gallery-item > a[href]",
        ),
    );
}

function getLightboxSlides(lightbox: HTMLElement): HTMLElement[]
{
    return Array.from(
        lightbox.querySelectorAll<HTMLElement>(".uk-lightbox-items > *"),
    );
}

function getActiveLightboxSlide(lightbox: HTMLElement): HTMLElement | null
{
    return lightbox.querySelector<HTMLElement>(".uk-lightbox-items > .uk-active");
}

function getActiveLightboxImage(lightbox: HTMLElement): HTMLImageElement | null
{
    return getActiveLightboxSlide(lightbox)?.querySelector<HTMLImageElement>("img") ?? null;
}

function getActiveLightboxIndex(lightbox: HTMLElement): number
{
    const slides = getLightboxSlides(lightbox);
    const activeSlide = getActiveLightboxSlide(lightbox);

    if (!activeSlide)
    {
        return 0;
    }

    const index = slides.indexOf(activeSlide);

    return index >= 0 ? index : 0;
}

function getUIkit(): UIkitGlobal | null
{
    return (window as typeof window & { UIkit?: UIkitGlobal }).UIkit ?? null;
}

function getLightboxPanel(lightbox: HTMLElement): UIkitLightboxPanel | null
{
    return getUIkit()?.getComponent(lightbox, "lightboxPanel") ?? null;
}

function removeDefaultProductLightboxNavigation(lightbox: HTMLElement): void
{
    lightbox
        .querySelectorAll<HTMLElement>(
            [
                ".uk-lightbox-nav",
                ".uk-lightbox-thumbnav",
                ".uk-thumbnav",
                ".uk-dotnav",
                ".uk-lightbox-caption",
            ].join(","),
        )
        .forEach((element) =>
        {
            element.remove();
        });
}

function updateProductLightboxZoomState(lightbox: HTMLElement): void
{
    const isZoomed = productLightboxState.zoom > PRODUCT_LIGHTBOX_MIN_ZOOM;

    lightbox.style.setProperty("--lightbox-zoom", String(productLightboxState.zoom));
    lightbox.classList.toggle("is-zoomed", isZoomed);
}

function updateProductLightboxZoomButtons(lightbox: HTMLElement): void
{
    const zoomOutButton = lightbox.querySelector<HTMLButtonElement>(
        '[data-product-lightbox-zoom="out"]',
    );

    const zoomInButton = lightbox.querySelector<HTMLButtonElement>(
        '[data-product-lightbox-zoom="in"]',
    );

    if (zoomOutButton)
    {
        zoomOutButton.disabled = productLightboxState.zoom <= PRODUCT_LIGHTBOX_MIN_ZOOM;
    }

    if (zoomInButton)
    {
        zoomInButton.disabled = productLightboxState.zoom >= PRODUCT_LIGHTBOX_MAX_ZOOM;
    }
}

function applyProductLightboxZoom(lightbox: HTMLElement): void
{
    const image = getActiveLightboxImage(lightbox);

    updateProductLightboxZoomState(lightbox);
    updateProductLightboxZoomButtons(lightbox);

    if (!image)
    {
        return;
    }

    image.style.transform = `scale(${productLightboxState.zoom})`;
    image.style.cursor = productLightboxState.zoom > PRODUCT_LIGHTBOX_MIN_ZOOM ? "zoom-out" : "zoom-in";
}

function setProductLightboxZoom(lightbox: HTMLElement, zoom: number): void
{
    productLightboxState.zoom = Math.min(
        PRODUCT_LIGHTBOX_MAX_ZOOM,
        Math.max(PRODUCT_LIGHTBOX_MIN_ZOOM, zoom),
    );

    applyProductLightboxZoom(lightbox);
}

function resetProductLightboxZoom(lightbox: HTMLElement): void
{
    setProductLightboxZoom(lightbox, PRODUCT_LIGHTBOX_MIN_ZOOM);
}

function changeProductLightboxZoom(lightbox: HTMLElement, direction: "in" | "out"): void
{
    const delta = direction === "in" ? PRODUCT_LIGHTBOX_ZOOM_STEP : -PRODUCT_LIGHTBOX_ZOOM_STEP;

    setProductLightboxZoom(lightbox, productLightboxState.zoom + delta);
}

function createProductLightboxControls(lightbox: HTMLElement): void
{
    if (lightbox.querySelector(".uk-lightbox__controls"))
    {
        return;
    }

    const controls = document.createElement("div");

    controls.className = "uk-lightbox__controls";

    controls.innerHTML = `
        <div class="uk-lightbox__zoom">
            <button
                type="button"
                class="uk-lightbox__zoom-button uk-lightbox__zoom-button--out"
                data-product-lightbox-zoom="out"
                aria-label="Uitzoomen"
                title="Uitzoomen"
            ></button>

            <button
                type="button"
                class="uk-lightbox__zoom-button uk-lightbox__zoom-button--in"
                data-product-lightbox-zoom="in"
                aria-label="Inzoomen"
                title="Inzoomen"
            ></button>
        </div>

        <ul class="uk-lightbox__thumbs" aria-label="Afbeelding thumbnails"></ul>
    `;

    controls.addEventListener("click", (event: MouseEvent) =>
    {
        const target = event.target as HTMLElement;
        const button = target.closest<HTMLButtonElement>("[data-product-lightbox-zoom]");

        if (!button || button.disabled)
        {
            return;
        }

        const direction = button.dataset.productLightboxZoom;

        if (direction !== "in" && direction !== "out")
        {
            return;
        }

        changeProductLightboxZoom(lightbox, direction);
    });

    lightbox.appendChild(controls);
    updateProductLightboxZoomButtons(lightbox);
}

function updateActiveProductLightboxThumbnail(lightbox: HTMLElement): void
{
    const activeIndex = getActiveLightboxIndex(lightbox);
    const buttons = lightbox.querySelectorAll<HTMLButtonElement>(".uk-lightbox__thumbs button");

    buttons.forEach((button, index) =>
    {
        const isActive = index === activeIndex;

        button.toggleAttribute("aria-current", isActive);
        button.closest("li")?.classList.toggle("uk-active", isActive);

        if (isActive)
        {
            button.scrollIntoView({
                block: "nearest",
                inline: "nearest",
            });
        }
    });
}

function navigateProductLightboxToIndex(lightbox: HTMLElement, targetIndex: number): void
{
    const slides = getLightboxSlides(lightbox);

    if (targetIndex < 0 || targetIndex >= slides.length)
    {
        return;
    }

    if (targetIndex === getActiveLightboxIndex(lightbox))
    {
        return;
    }

    const lightboxPanel = getLightboxPanel(lightbox);

    if (!lightboxPanel?.show)
    {
        return;
    }

    resetProductLightboxZoom(lightbox);
    lightboxPanel.show(targetIndex);
}

function createProductLightboxThumbnails(lightbox: HTMLElement): void
{
    const thumbList = lightbox.querySelector<HTMLUListElement>(".uk-lightbox__thumbs");

    if (!thumbList)
    {
        return;
    }

    const galleryLinks = getOriginalGalleryLinks();
    const fragment = document.createDocumentFragment();

    galleryLinks.forEach((galleryLink, index) =>
    {
        const galleryImage = galleryLink.querySelector<HTMLImageElement>("img");

        const thumbnailSource =
            galleryLink.dataset.thumbnail ||
            galleryImage?.currentSrc ||
            galleryImage?.src ||
            galleryLink.href;

        const caption =
            galleryLink.dataset.caption ||
            galleryLink.title ||
            `Afbeelding ${index + 1}`;

        const listItem = document.createElement("li");
        const button = document.createElement("button");
        const image = document.createElement("img");

        button.type = "button";
        button.dataset.lightboxIndex = String(index);
        button.setAttribute("aria-label", `Open ${caption}`);

        image.src = thumbnailSource;
        image.alt = "";
        image.width = 59;
        image.height = 58;
        image.loading = "lazy";

        button.appendChild(image);
        listItem.appendChild(button);
        fragment.appendChild(listItem);
    });

    thumbList.replaceChildren(fragment);
    updateActiveProductLightboxThumbnail(lightbox);
}

function addProductLightboxThumbnailNavigation(lightbox: HTMLElement): void
{
    const thumbList = lightbox.querySelector<HTMLElement>(".uk-lightbox__thumbs");

    if (!thumbList)
    {
        return;
    }

    thumbList.addEventListener("click", (event: MouseEvent) =>
    {
        const target = event.target as HTMLElement;
        const button = target.closest<HTMLButtonElement>("[data-lightbox-index]");

        if (!button)
        {
            return;
        }

        const index = Number(button.dataset.lightboxIndex);

        if (!Number.isInteger(index))
        {
            return;
        }

        navigateProductLightboxToIndex(lightbox, index);
    });
}

function addProductLightboxImageZoom(lightbox: HTMLElement): void
{
    lightbox.addEventListener("click", (event: MouseEvent) =>
    {
        const target = event.target;

        if (!(target instanceof HTMLImageElement) || !target.closest(".uk-lightbox-items > .uk-active"))
        {
            return;
        }

        const nextZoom = productLightboxState.zoom > PRODUCT_LIGHTBOX_MIN_ZOOM
            ? PRODUCT_LIGHTBOX_MIN_ZOOM
            : productLightboxState.zoom + PRODUCT_LIGHTBOX_ZOOM_STEP;

        setProductLightboxZoom(lightbox, nextZoom);
    });
}

function addProductLightboxWheelZoom(lightbox: HTMLElement): void
{
    lightbox.addEventListener("wheel", (event: WheelEvent) =>
    {
        const activeSlide = getActiveLightboxSlide(lightbox);
        const target = event.target;

        if (!activeSlide || !(target instanceof Node) || !activeSlide.contains(target))
        {
            return;
        }

        event.preventDefault();

        changeProductLightboxZoom(lightbox, event.deltaY < 0 ? "in" : "out");
    }, {
        passive: false,
    });
}

function observeProductLightboxSlides(lightbox: HTMLElement): void
{
    const lightboxItems = lightbox.querySelector<HTMLElement>(".uk-lightbox-items");

    if (!lightboxItems)
    {
        return;
    }

    let activeIndex = getActiveLightboxIndex(lightbox);

    const observer = new MutationObserver(() =>
    {
        const nextActiveIndex = getActiveLightboxIndex(lightbox);

        if (nextActiveIndex === activeIndex)
        {
            return;
        }

        activeIndex = nextActiveIndex;

        resetProductLightboxZoom(lightbox);
        updateActiveProductLightboxThumbnail(lightbox);
    });

    observer.observe(lightboxItems, {
        attributes: true,
        subtree: true,
        attributeFilter: ["class"],
    });
}

function initializeProductLightbox(lightbox: HTMLElement): void
{
    if (lightbox.dataset.productLightboxInitialized === "true")
    {
        return;
    }

    lightbox.dataset.productLightboxInitialized = "true";
    productLightboxState.zoom = PRODUCT_LIGHTBOX_MIN_ZOOM;

    removeDefaultProductLightboxNavigation(lightbox);
    createProductLightboxControls(lightbox);
    createProductLightboxThumbnails(lightbox);
    addProductLightboxThumbnailNavigation(lightbox);
    addProductLightboxImageZoom(lightbox);
    addProductLightboxWheelZoom(lightbox);
    observeProductLightboxSlides(lightbox);
    resetProductLightboxZoom(lightbox);
}

function observeProductLightboxCreation(): void
{
    const initialize = (): void =>
    {
        const lightbox = getProductLightbox();

        if (lightbox)
        {
            initializeProductLightbox(lightbox);
        }
    };

    initialize();

    const observer = new MutationObserver(initialize);

    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

const initColorTiles = () =>
{
    document.querySelectorAll(".js-product-spec-toggle").forEach((item) =>
    {
        const parent = $(item).closest(".c-product-spec");
        $(item).off("click");
        $(item).on("click", function ()
        {
            if ($(parent).hasClass("c-product-spec--expanded"))
                $(parent).removeClass("c-product-spec--expanded");
            else
                $(parent).addClass("c-product-spec--expanded");
        });

        if ($(parent).find(".js-product-change-selection").length <= 4)
            $(parent).find(".js-product-spec-toggle").addClass("hidden");
    });
}

export const changeSelection = (selectElement) =>
{
    let propID = $(selectElement).prop("name");

    if (typeof (propID) === typeof (undefined) || propID == null)
        propID = $(selectElement).data("name");

    propID = propID.replace("property", "");

    if ($(selectElement).hasClass("selection-block"))
    {
        $(selectElement).parent().find(".selection-block.selected").removeClass("selected");
        $(selectElement).addClass("selected");
    }

    reloadProductDetail(propID, false, false);
}

(window as any).changeSelection = changeSelection;

let pdpLoader: progressSpinner;

export const showLoader = () =>
{
    pdpLoader = new progressSpinner(".w-main", spinnerType.smulders);
    pdpLoader.show(true);
};

(window as any).showLoader = showLoader;

const disableMobileEvents = () =>
{
    // Implement if needed
};

var productDetailReloaded = false;
var slideShowHeight;

function reloadProductDetail(propid, isSmallCart, isStickyDropDown)
{
    slideShowHeight = $(".product-holder:not(.popup-product-holder) .slideshow").height();

    if (!productDetailReloaded)
    {
        showLoader();
        productDetailReloaded = true;
        var url = "";
        var id = $("#shopid").val();

        /* Get all properties within the related article div and put them in the url.*/
        let $props: JQuery<HTMLInputElement>;

        if (isSmallCart)
        {
            $props = $(
                ".addcart-small-specs select[name^='property']"
            );
        }
        else if (isStickyDropDown)
        {
            $props = $(
                ".btp-caption select[name^='property']"
            );
        }
        else
        {
            $props = $(
                ".js-article-data select[name^='property']," +
                ".js-article-data .hidden-select-mobile select[name^='property']," +
                ".js-article-data input[type='hidden'][name^='property']," +
                ".js-article-data input[type='hidden'][data-singlepropertyoption^='property']," +
                ".js-article-data .selection-block.selected"
            );
        }

        if (propid != null && propid != 'undefined')
            url += "&lastSel=" + propid;

        for (let i = 0; i < $props.length; i++)
        {
            if ($props[i].getAttribute("data-singlepropertyoption") != null)
            {
                // Get property and option in array.
                var propertyOption = $props[i].getAttribute("data-singlepropertyoption").split("-");

                // Append the URL part for property/option.
                if (propertyOption.length > 1)
                    url += "&" + propertyOption[0] + "=" + propertyOption[1];
            }
            else if (
                $props[i].name &&
                $props[i].name.length > 0 &&
                $props[i].value &&
                $props[i].value.length > 0 &&
                $props[i].value != "0"
            )
                url += "&" + $props[i].name + "=" + $props[i].value;
            else if (
                $props[i].getAttribute("data-name") &&
                $props[i].getAttribute("data-name").length > 0 &&
                $props[i].getAttribute("data-value") &&
                $props[i].getAttribute("data-value").length > 0 &&
                $props[i].getAttribute("data-value") != "0"
            )
                url += "&" + $props[i].getAttribute("data-name") + "=" + $props[i].getAttribute("data-value");
        }

        var args = new Array();
        args["id"] = id;

        if (document.getElementById("wrapper").classList.contains("ab-mobile-color-selection-alt"))
        {
            const width = window.innerWidth;
    
            if (width >= 769)
                url = url.replace(/property3_mobile=\d+&/g, "");
            else
            {
                url = url.replace(/property3=\d+&/g, "&");
                url = url.replace("&property3_mobile", "property3");
            }
        }
        else
            url = url.replace(/property3_mobile=\d+&/g, "");

        args["vars"] = url;

        $.get("/Services/Modules/Webshop.asmx/ShowDetail?action=showdetail&shopid=" + id + url, function (data)
        {
            fillProductDetail(data);
            disableMobileEvents();
            setTimeout(() =>
            {
                initLazyLoad();
            }, 100);
        });
    }
}

let pageMeta: PageMeta;
let metaTitle = "";
export const replaceMetaData = (data) =>
{
    // Meta title
    pageMeta.title = pageMeta.title.replace(metaTitle, $("#metatitle").val().toString());

    // Canonical
    let newProductLink = $(".js-pdp-article-link").data("href");

    // Remove /shopart/ from url
    newProductLink = newProductLink.replace(/\/shopart\/\d+\/?/, '');
    pageMeta.canonical = newProductLink;

    // Images
    let newImageUrl = $(data).find("picture img").attr("src");
    pageMeta.ogImage = newImageUrl;
    pageMeta.twitterImage = newImageUrl;

    metaManager.updateHtml(null, pageMeta);
};

export const replaceBreadcrumb = (data) =>
{
    //check if the document referrer is empty
    if (document.referrer == "" || !$.stash.exists("lastCategoryUrl"))
    {
        $(".j-breadcrumbs .c-breadcrumbs__item:last .c-breadcrumbs__link").attr("href", $(data).find(".js-pdp-article-link").data("href"));
    }
    else if ($.stash.exists("lastCategoryUrl"))
    {
        var safeLastCategoryUrl = $.stash.get("lastCategoryUrl");

        if (safeLastCategoryUrl.indexOf('#') > 0)
            safeLastCategoryUrl = safeLastCategoryUrl.substring(0, safeLastCategoryUrl.indexOf('#'));

        var safeReferrer = document.referrer.replace(/^[^:]+:\/\/[^/]+/, '').replace(/#.*/, '');
        var previousLinkUrl = $(".js-pdp-controls .prev").attr("href");
        var nextLinkUrl = $(".js-pdp-controls .next").attr("href");

        if (safeReferrer.indexOf('shopart') > 0)
            safeReferrer = safeReferrer.substring(0, safeReferrer.indexOf('shopart'));

        // Get the product item from the breadcrumb
        var product = $(".j-breadcrumbs div a").last().parent().clone();

        if (document.referrer == safeLastCategoryUrl ||
            nextLinkUrl == safeReferrer ||
            previousLinkUrl == safeReferrer)
        {
            // Remove current breadcrumb items
            $(".j-breadcrumbs").empty();

            // Get the last breadcrumb from the stash
            var lastBreadcrumb = $.stash.get("lastBreadcrumb");

            // Split to the items
            var breadcrumbOptions = lastBreadcrumb.split("||");

            // Loop through the items
            for (var i = 0; i < breadcrumbOptions.length; i++)
            {
                // Skip empty items
                if (breadcrumbOptions[i] == "" || breadcrumbOptions[i] == undefined)
                    continue;

                // Skip page
                if (breadcrumbOptions[i].includes("?page="))
                    continue;

                // bc[0] is url, bc[1] is title
                var bc = breadcrumbOptions[i].split("|");

                // Create links
                $(".j-breadcrumbs").append(
                    $("<div class=\"c-breadcrumbs__item\"><a class=\"c-breadcrumbs__link\" href=\"" + bc[0] + "\" title=\"" + bc[1] + "\"><span class=\"c-breadcrumbs__text\">" + bc[1] + "</span></a></div>"));

            }
            // Re-add product item
            $(".j-breadcrumbs").append(product);
        }
        else if (safeLastCategoryUrl === getTranslations().searchUrl)
        {
            // Remove current breadcrumb items
            $(".j-breadcrumbs").empty();

            $(".j-breadcrumbs").append($("<div class=\"c-breadcrumbs__item\"><a class=\"c-breadcrumbs__link\" href=\"/\" title=\"" + getTranslations().txtUtilHome + "\"><span class=\"c-breadcrumbs__text\">" + getTranslations().txtUtilHome + "</span></a></div>"));

            $(".j-breadcrumbs").append($("<div class=\"c-breadcrumbs__item\"><a class=\"c-breadcrumbs__link\" href=\"" + getTranslations().searchUrl + "\" title=\"" + getTranslations().txtUtilSearch + "\"><span class=\"c-breadcrumbs__text\">" + getTranslations().txtUtilSearch + "</span></a></div>"));

            $(".j-breadcrumbs").append(product);
        }
        else if (safeLastCategoryUrl == getTranslations().shoppingCartUrlLowerCaseTxt)
        {
            // Do nothing
        }
        else
        {
            // Remove current breadcrumb items
            $(".j-breadcrumbs").empty();

            $(".j-breadcrumbs").append($("<div class=\"c-breadcrumbs__item\"><a class=\"c-breadcrumbs__link\" href=\"/\" title=\"" + getTranslations().txtUtilHome + "\"><span class=\"c-breadcrumbs__text\">" + getTranslations().txtUtilHome + "</span></a></div>"));

            $(".j-breadcrumbs").append(product);
        }
    }

    sendBreadCrumbImpression();
};

export const setProductDetailEvents = () =>
{
    // TODO add events
    observeProductLightboxCreation();
    initProductSelectionPopup();
    initBundleSelectionPopup();
    initBundlePackageSelectionPopup();
    productDetailReloaded = false;
}

function fillProductDetail(data)
{
    initUspLabels();
    pageMeta = metaManager.parseFromHtml($("head")[0].innerHTML);
    metaTitle = $("#metatitle").val().toString();

    // Replace content
    replaceBreadcrumb(data);
    replaceContentSmooth(".js-pdp-replacement", $(data).html(), false).then(() =>
    {
        $("#cart-template").replaceWith($(data).find("#cart-template"));
        processMarkedForRemove();
        reInitTooltips();
        reInitProductComparer();
        reInitYoutubePlayer();
        reInitAr();
        sendLastViewedProduct();
        setProductDetailEvents();
        initNoStockMessage();
        initExpectedDeliveryCartButton();
        initAccordion();
        initBundleEvents(false);
        replaceMetaData(data);
        initColorTiles();
        initStickyBar(null, null);
        initSoldoutAlternativeButton();
        initProperty3SelectedImage();
        abMobileColorSelection();
        updateSideImage();
        new FavoritePopup();

        document.querySelectorAll<HTMLElement>(".c-product-detail__prices").forEach((prices) =>
        {
            const oldPrice = prices.querySelector<HTMLElement>(".ofprice");

            prices.classList.toggle("has-old-price", !!oldPrice?.textContent?.trim());
        });

        try
        {
            const imageUl = document.getElementsByClassName("product-gallery-item")[0].parentNode;
            const freestandingImage = imageUl.querySelector('[data-imagetype="vrijstaand"]');

            if (freestandingImage)
            {
                imageUl.removeChild(freestandingImage);
                imageUl.appendChild(freestandingImage);
            }
        }
        catch { }

        reInitSlider();

        var url = $(".js-pdp-article-link").data("href");

        if (url && url.length > 0)
        {
            try
            {
                var replaceUrl = url;

                // Used for Spotler personalization testing. When testing on PDP, keep test parameter in URL.
                if (window.location.href.indexOf("?testproductbundles") > 0 &&
                    replaceUrl.indexOf("?") < 0
                )
                    replaceUrl += "?testproductbundles";

                history.replaceState({}, "", replaceUrl);
                pdpSpotler(true);
            }
            catch (err)
            {
                console.error(err);
            }
        }

        pdpLoader.hide();
    });

    setTimeout(() =>
    {
        loadInstagramPosts();
    }, 2000);
}

let spotlerProductsToPush;
let spotlerPushProducts;
let spotlerEventData;
declare let loadSpotlerPushProducts: any;

const pdpSpotler = (sendSpotlerViewContent: boolean) =>
{
    if (sendSpotlerViewContent)
    {
        // Variables originate from external script. See RSMUL-17060.
        if (typeof (spotlerProductsToPush) !== typeof (undefined) &&
            spotlerProductsToPush != null &&
            typeof (spotlerPushProducts) !== typeof (undefined) &&
            spotlerPushProducts != null &&
            typeof (loadSpotlerPushProducts) === "function")
        {
            // Load new article item data.
            const items = getProductDetailImpression();

            // Reset values.
            spotlerProductsToPush = [items];
            spotlerPushProducts = [];
            spotlerEventData = { event: "ViewContent" };

            // Load items into 'spotlerPushProducts'.
            loadSpotlerPushProducts();
            // First trigger reload.
            window._sqzl = window._sqzl || [];
            window._sqzl.push({
                "event": "ReloadPersonalization"
            });

            // Send ViewContent event after reload.
            spotlerEventData.products = spotlerPushProducts;
            window._sqzl.push(spotlerEventData);
        }
    }
}

const initStickyBar = (articleID: number | null, optionID: number | null) =>
{
    const content = $("<div class=\"w-sticky-bar__content\"></div>")[0];
    let hasProperties = false;
    STICKY_PROPERTIES.forEach((name) =>
    {
        if ($(`.c-product-detail__option-group [name=${name}]`).length > 0)
        {
            hasProperties = true;
            const select = $(`.c-product-detail__option-group [name=${name}]`).clone();
            select.removeAttr("id");
            const propertyID = parseInt(select.attr("name").replace("property", ""));
            select.removeAttr("name");
            if (optionID)
                select.val(optionID);

            const selectWrapper = document.createElement("div");
            selectWrapper.className = "u-select-holder";
            selectWrapper.appendChild(select[0]);
            content.appendChild(selectWrapper);
            content.classList.add("js-pdp-property-identifier");
            content.id = "pdp-sticky-property" + propertyID;

            const productID = parseInt($("#shopid").val().toString());

            $(select).on("change", (e) =>
            {
                const value = (e.target as HTMLSelectElement).value;
                const optionID = parseInt(value);
                $(`[name=property${propertyID}`).val(optionID);
                getArticle(productID, null, propertyID, optionID, null, (data) =>
                {
                    const articleID = data.d.ArticleID;

                    initStickyBar(articleID, optionID);
                });
            });
        }
    });

    if (!articleID)
        articleID = parseInt($("#shopart").val().toString());

    const button = $(`<button class="c-product-detail__cart-button btn btn-green btn-icon-cart js-cart-add-article" onclick="addProductDetailProduct(this); addArticleToCart($(this), ${articleID}, ${shopConfig().useAddToCartPopup}, false, false, false); return false;">${getTranslations().inCartText}</button>`);

    if (!hasProperties)
    {
        button.addClass("full-width");
        content.classList.remove("w-sticky-bar__content");
    }

    content.appendChild(button[0]);

    const contentWrapper = document.createElement("div");
    contentWrapper.appendChild(content);
    if (isProductfeed)
    {
        const productFeedButton = $(".js-productfeed-btn")[0];
        productFeedButton.className = "btn-text-link";
        contentWrapper.appendChild(productFeedButton);
    }

    stickybarInstance = new stickybar(contentWrapper);

    if (stickybarInstance.initialized)
        $('body').addClass('c-productcomparer-widget-raised');

    initProductSelectionPopup();
}

const getArticle = (pid: number | null, aid: number | null, propertyID: number | null, optionID: number | null, combiBundleTypeName: string | null, callback: any) =>
{
    let url = "/Services/Modules/Webshop.asmx/ShowCartPopupForArticle";
    let firstParam = true;

    if (pid)
    {
        firstParam = false;
        url += "?shopid=" + pid;
    }

    if (aid)
    {
        firstParam = false;
        url += (firstParam ? "?" : "&") + "aid=" + aid;
    }

    if (propertyID)
    {
        firstParam = false;
        url += (firstParam ? "?" : "&") + "lastSel=" + propertyID;
        url += "&property" + propertyID + "=" + optionID;
        url += "&property=" + propertyID;
    }

    url += (firstParam ? "?" : "&") + "quantity=1";

    if (combiBundleTypeName?.length > 0)
        url += (firstParam ? "?" : "&") + "bundletypename=" + combiBundleTypeName;

    $.ajax({
        type: "POST",
        url: url,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        error: function (jqXHR, textStatus, errorThrown)
        {
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        },
        success: callback
    });
}

// sale text is only shown when there is an old price, so we need to check if there is an old price and add a class to the prices container if there is one.
document.querySelectorAll<HTMLElement>(".c-product-detail__prices").forEach((prices) =>
{
    const oldPrice = prices.querySelector<HTMLElement>(".ofprice");

    prices.classList.toggle("has-old-price", !!oldPrice?.textContent?.trim());
});

//#region DOM contet loaded

if (document.readyState === "loading")
{
    document.addEventListener(
        "DOMContentLoaded",
        initProductSelectionPopup
    );

    document.addEventListener(
        "DOMContentLoaded",
        initBundleSelectionPopup
    );

    document.addEventListener(
        "DOMContentLoaded",
        initBundlePackageSelectionPopup
    );
}
else
{
    initProductSelectionPopup();
    initBundleSelectionPopup();
    initBundlePackageSelectionPopup();
}

if (document.readyState === "loading")
{
    document.addEventListener("DOMContentLoaded", observeProductLightboxCreation, {
        once: true,
    });
}
else
    observeProductLightboxCreation();

document.addEventListener("DOMContentLoaded", () =>
{
    initColorTiles();
    initNoStockMessage();
    initSoldoutAlternativeButton();
    initExpectedDeliveryCartButton();
    abMobileColorSelection();
});

//#endregion DOM content loaded

const initProperty3SelectedImage = () => {
    const popup = document.querySelector("#modal-pdp-property3");
    const selector = document.querySelector("select[name=property3_mobile]");

    if (!popup || !selector)
        return;

    const activeColor = popup.querySelector(".c-popup__radio-holder--active");

    if (!activeColor)
        return;

    const imageElement = activeColor.querySelector("img");

    if (!imageElement)
        return;

    selector.parentElement.prepend(imageElement.cloneNode(true));
}

initProperty3SelectedImage();

//#region RSMUL-22528 A/B-test

export const abMobileColorSelection = () =>
{
    if (document.getElementById("wrapper").classList.contains("ab-mobile-color-selection-alt"))
    {
        const defaultClass = ".ab-mobile-color-selection";

        $(defaultClass + "--mobile").addClass("show-mobile");
        $(defaultClass + "--mobile").removeClass("hidden");
        $(defaultClass + "--desktop").addClass("show-desktop");
    }
}

(window as any).abMobileColorSelection = abMobileColorSelection;

//#endregion RSMUL-22528 A/B-test
